import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { Flex, Box } from 'reflexbox';
import set from 'set-value';
import BackupIcon from '@material-ui/icons/Backup';

import * as actions from '../../redux/organisations';
import DynamicForm from '../DynamicForm/DynamicForm';
import DynamicDialog from '../DynamicDialog/DynamicDialog';
import { Schema, BannerSchema } from './InputSchema';
import { validated } from '../../helpers'
import {
  HeaderContainer, HeaderTitle, BounceAnimatedContainer, PaperContainer,
  HorizontalRule, CentredContainer, HealtheraButton, BackButton,
} from '../../healtheraComponents';
import {
  FileLabel, FileSelector, flexStyles, LogoView,
  BannerImage, BannerLink, BannerLinkLabel, BannerTitle,
  BannerButton, BannerButtonDelete,
} from './styles';
import NotificationPopup from '../NotificationPopup';
import ClinicSelector from '../ClinicSelector';
import { InputLabel } from '@material-ui/core';
import { ColumnWithGap } from '../PlusWebsiteEditor/sections/HeroBlock/HeroBlock.styled';
import FeatureFlags from './FeatureFlags';

function WhiteLabelDetails(props) {
  const [logoWhite, setLogoWhite] = useState({ files: [] });
  const [logo, setLogo] = useState({ files: [] });
  const [bannerImg, setBannerImg] = useState({ files: [] });
  const [logoInput, setLogoInput] = useState(null);
  const [logoWhiteInput, setLogoWhiteInput] = useState(null);
  const [bannerImgInput, setBannerImgInput] = useState(null);
  const [whiteLabelDetails, setWhiteLabelDetails] = useState({});
  const [validationArray, setValidationArray] = useState([]);
  const [bannerValidationArray, setBannerValidationArray] = useState([]);
  const [showAddBannerModal, setShowAddBannerModal] = useState(false);
  const [bannerSchema, setBannerSchema] = useState({});
  const [bannerData, setBannerData] = useState({});
  const [bannerUpdateData, setBannerUpdateData] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  const dispatch = useDispatch();

  const {
    whiteLabelApp,
    whiteLabelMessage,
  } = useSelector(state => state.organisations);

  const {
    match: { params: { appId } = {} } = {},
    history,
  } = props;
  const { branding, banners } = whiteLabelApp || {};
  const { logo_url_white, logo_url } = branding || {};
  const schema = Schema(whiteLabelApp);

  const goBack = () => history.push(`${process.env.PUBLIC_URL}/whitelabels`);

  const openBannerModal = () => {
    setBannerImg({ files: [] });
    setBannerImgInput(null);
    setShowAddBannerModal(true);
  };

  const addBanner = () => {
    setBannerData({});
    setBannerUpdateData({});
    setBannerSchema(BannerSchema());
    openBannerModal();
  };

  const editBanner = id => {
    const banner = banners.find(i => i.bannerID === id) || {};
    setBannerData(banner);
    setBannerUpdateData({ id });
    setBannerSchema(BannerSchema(banner));
    openBannerModal();
  };

  const closeBannerModal = () => setShowAddBannerModal(false);

  const onChange = ({ field, value, validation }) => {
    set(validationArray, field, validation);
    set(whiteLabelDetails, field, value);
    setValidationArray(validationArray);
    setWhiteLabelDetails(whiteLabelDetails);
  };

  const onChangeBannerData = ({ field, value, validation }) => {
    set(bannerValidationArray, field, validation);
    set(bannerUpdateData, field, value);
    setBannerValidationArray(bannerValidationArray);
    setBannerUpdateData(bannerUpdateData);
  };

  const onChangeFile = (callback, value) => {
    try {
      if (value.files[0]) {
        if (value.files[0].size < 15000000) {
          callback(value);
        } else {
          alert('image size is too big');
        }
      }
    } catch (e) { }
  };

  const notify = (message) => {
    setNotificationMessage(message);
    setShowNotification(true);
  };

  const deleteBanner = async id => {
    await dispatch(actions.deleteWhiteLabelBanner(appId, id));
    dispatch(actions.getWhiteLabelApp(appId));
  };

  const applyBannerModal = async () => {
    if (!validated(bannerValidationArray)) {
      notify('Can not validate banner form.');
      return;
    }

    const { id, ...body } = bannerUpdateData;
    const fd = new FormData();

    if (bannerImg.files[0]) fd.append('banner_img', bannerImg.files[0]);
    if (body.title) fd.append('title', body.title);
    if (body.link) fd.append('link', body.link);

    if (id) {
      await dispatch(actions.editWhiteLabelBanner(appId, id, fd));
    } else {
      await dispatch(actions.addWhiteLabelBanner(appId, fd));
    }

    dispatch(actions.getWhiteLabelApp(appId));
    setShowAddBannerModal(false);
  };

  const handleChangeClinic = (clinicId) => {
    setWhiteLabelDetails({ ...whiteLabelDetails, clinic_id: clinicId });
  }

  const handleChangeFlag = (flag, checked) => {
    setWhiteLabelDetails(currentWhiteLabelDetails => ({
      ...currentWhiteLabelDetails,
      feature_flags: {
        ...currentWhiteLabelDetails.feature_flags,
        [flag]: checked
      }
    }));
  };

  const handleSubmit = async () => {
    if (!validated(validationArray)) {
      notify('Can not validate the form.');
      return;
    }

    if (logo.files[0] || logoWhite.files[0]) {
      const fd = new FormData();
      if (logo.files[0]) fd.append('logo_url', logo.files[0]);
      if (logoWhite.files[0]) fd.append('logo_url_white', logoWhite.files[0]);
      await dispatch(actions.putWhiteLabelApp(appId, fd));
    }

    await dispatch(actions.putWhiteLabelApp(appId, whiteLabelDetails));
    dispatch(actions.getWhiteLabelApp(appId));
  };

  useEffect(() => {
    dispatch(actions.getWhiteLabelApp(appId));
  }, [dispatch, appId]);

  useEffect(() => {
    whiteLabelMessage && notify(whiteLabelMessage);
  }, [whiteLabelMessage]);

  const renderBannerModal = () => {
    const actions = (
      <>
        <HealtheraButton onClick={closeBannerModal} margin={'0 10px 5px'} height={'32px'} width={'95px'} color="primary">
          Cancel
        </HealtheraButton>
        <HealtheraButton onClick={applyBannerModal} margin={'0 10px 5px'} height={'32px'}  width={'95px'} >
          Update
        </HealtheraButton>
      </>
    );

    const modalContent = (
      <>
        <Box style={{ textAlign: 'center' }}>
          {bannerData && bannerData.url && (
            <Box>
              <BannerImage src={bannerData.url} />
            </Box>
          )}
          <FileSelector
            type='file'
            name='banner_img'
            id='banner_img'
            ref={ref => setBannerImgInput(ref)}
            onChange={() => onChangeFile(setBannerImg, bannerImgInput)}
            accept="image/png, image/jpeg"
          />
          <FileLabel htmlFor='banner_img'>
            {(bannerImg.files[0] || { name: <>Choose a banner image <BackupIcon /></> }).name}
          </FileLabel>
        </Box>
        <DynamicForm
          onChange={onChangeBannerData}
          fields={bannerSchema.banners}
        />
      </>
    );

    return (
      <DynamicDialog
        open={showAddBannerModal}
        title="Marketing Banner"
        field={modalContent}
        actions={actions}
      />
    );
  };

  return (
    <>
      <NotificationPopup
        isOpen={showNotification}
        onClose={() => setShowNotification(false)}
        message={notificationMessage}
      />
      {whiteLabelApp && <BounceAnimatedContainer>
        <HeaderContainer padding={`20px 0 20px 0`} onClick={goBack} borderbottom={`none`} p={2} align='center'>
          <BackButton padding={`0 5px 0 0`} />
          <HeaderTitle cursor={`pointer`} px={2} w={1 / 3}>White Labels</HeaderTitle>
        </HeaderContainer>
        <PaperContainer $margintop={26} elevation={0}>
          <HeaderContainer marginright={`0px`} padding={`0 0 20px 0`}>
            <HeaderTitle fontSize={`24px`}>Details & Brand Assets</HeaderTitle>
          </HeaderContainer>
          <Flex>
            <Box w={`50%`}>
              <DynamicForm
                onChange={onChange}
                fields={schema.brandingLeft}
              />
            </Box>
            <Box w={`50%`}>
              <Flex style={flexStyles}>
                <Box width={1 / 4}>
                  <LogoView src={logo_url} />
                </Box>
                <Box width={1 / 4}>
                  <FileSelector
                    type='file'
                    name='logo_url'
                    id='logo_url'
                    ref={ref => setLogoInput(ref)}
                    onChange={() => onChangeFile(setLogo, logoInput)}
                    accept="image/png, image/jpeg"
                  />
                  <FileLabel htmlFor='logo_url'>
                    {(logo.files[0] || { name: <>Choose a logo <BackupIcon /></> }).name}
                  </FileLabel>
                </Box>
                <Box width={1 / 4}>
                  <LogoView src={logo_url_white} />
                </Box>
                <Box width={1 / 4}>
                  <FileSelector
                    type='file'
                    name='logo_url_white'
                    id='logo_url_white'
                    ref={ref => setLogoWhiteInput(ref)}
                    onChange={() => onChangeFile(setLogoWhite, logoWhiteInput)}
                    accept="image/png, image/jpeg"
                  />
                  <FileLabel htmlFor='logo_url_white'>
                    {(logoWhite.files[0] || { name: <>Choose a white logo <BackupIcon /></> }).name}
                  </FileLabel>
                </Box>
              </Flex>
            </Box>
          </Flex>
          <HorizontalRule margin={`50px 0 0 0`} />
          <Flex>
            <Box w={`50%`} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <DynamicForm onChange={onChange} fields={schema.mobileAppLinksLeft} />
              <ClinicEditor onChange={handleChangeClinic} />
              <FeatureFlags onChange={handleChangeFlag} whiteLabelUpdatePayload={whiteLabelDetails} />
            </Box>
            <Box w={`50%`}>
              <Flex style={{
                ...flexStyles,
                padding: '20px 30px',
              }}>
                {banners?.length ? (<>
                  {banners.map(banner => {
                    const { title, bannerID, url, link } = banner;
                    return (
                      <Box style={{ width: '100%' }} key={bannerID}>
                        <BannerImage src={url} />
                        <BannerTitle>{title}</BannerTitle>
                        <Box>
                          <BannerLinkLabel>External link:</BannerLinkLabel>
                          <BannerLink href={link} target="_blank" >{link}</BannerLink>
                        </Box>
                        <Box>
                          <BannerButton onClick={() => editBanner(bannerID)}>Edit</BannerButton>
                          <span style={{ margin: '0 15px' }}>|</span>
                          <BannerButtonDelete onClick={() => deleteBanner(bannerID)}>Delete</BannerButtonDelete>
                        </Box>
                        <HorizontalRule style={{ margin: '20px 0' }} width="95%" />
                      </Box>
                    );
                  })}
                </>) : null}
                <HealtheraButton onClick={addBanner}>Add another banner</HealtheraButton>
              </Flex>
            </Box>
          </Flex>
          <Flex>
            <CentredContainer padding={`40px 0 20px 0`} style={{ margin: '60px auto 0 auto' }}>
              <HealtheraButton onClick={handleSubmit}>Save</HealtheraButton>
            </CentredContainer>
          </Flex>
        </PaperContainer>
        </BounceAnimatedContainer>
      }
      {renderBannerModal()}
    </>
  )
}

function ClinicEditor({ onChange }) {
  const { whiteLabelApp } = useSelector(state => state.organisations);

  const [clinicId, setClinicId] = useState(null);

  useEffect(() => {
    if (whiteLabelApp?.clinic_id) {
      setClinicId(whiteLabelApp.clinic_id);
    }
  }, [whiteLabelApp?.clinic_id]);

  const handleChange = (clinicId) => {
    setClinicId(clinicId);
    onChange(clinicId);
  }

  return (
    <ColumnWithGap>
      <InputLabel>Clinic</InputLabel>
      <ClinicSelector value={clinicId} onChange={handleChange} />
    </ColumnWithGap>
  );
}

export default withRouter(WhiteLabelDetails);
